import classNames from 'classnames/bind';
import React from 'react';

import Geomagnetic from './Geomagnetic';
import styles from './index.module.scss';
import Weather from './Weather';

import Bar from '@/components/ui/Bar';
import Geo from '@/components/ui/Geo';
import TimeClock from '@/components/ui/TimeClock';

const cx = classNames.bind(styles);

const BottomBar = () => {
  return (
    <div className={cx('container')}>
      {process.env.REACT_APP_USE_WEATHER === 'true' && <Weather />}
      {process.env.REACT_APP_USE_GEO_MAGNETIC === 'true' && <Geomagnetic />}
      <Bar size={28} />
      <Geo />
      <TimeClock />
    </div>
  );
};

export default BottomBar;
